const initialState = {
    currentTab: 'all-intents',
}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case 'CHANGE_TAB':
            return {
                ...state,
                currentTab: action.idx,
            }
        case 'RESET_TAB':
            return {
                ...initialState,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/currentTab.js